import React from 'react';

const Tick: React.FC = () => {
  return (
    <svg viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.8213 28.2457L0.869143 17.3686C-0.155083 16.2529 0.0649504 14.6231 1.36568 13.7391C2.66641 12.855 4.54935 13.0439 5.58136 14.1674L10.6266 19.6839L25.7991 1.74045C26.7747 0.585761 28.6537 0.324836 29.9934 1.16992C31.3311 2.01111 31.6232 3.63116 30.6516 4.78585L10.8213 28.2457Z" />
    </svg>
  );
};

export { Tick };
